export const VERSION_COOKIE = "PBFEVersion"
export const GRAPH_URL_COOKIE = "PBFEGraphUrl"
export const API_GW_URL_COOKIE = "PBFEAPIGWUrl"

export default {VERSION_COOKIE, GRAPH_URL_COOKIE, API_GW_URL_COOKIE}
